import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL, OLD_API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from "../../constant";
import axios from "axios";

/**
 * Fetch Featured Brands    
 */
export const fetchFeaturedBrands = createAsyncThunk('brand/fetchFeaturedBrands', async (_, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + '/featured-brands', {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        return res.data;
    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage); 
    }
});

/**
 * Fetch Brand Products    
 */
export const fetchBrandProducts = createAsyncThunk('brand/fetchBrandProducts', async (brand, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/brands/${brand}/products`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        return { brand, products: res.data };

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});

/**
 * Fetch All Brands
 */
export const fetchAllBrands = createAsyncThunk('brand/fetchAllBrands', async (_, { rejectWithValue }) => {
    try {
        const collectedBrands = [];
        let page = 1;
        let lastPage = 1;

        do {
            const res = await axios.get(`${OLD_API_BASE_URL}/allbrands_app?page=${page}`, {
                headers: {
                    'X-API-KEY-ID': API_KEY_ID,
                    'X-API-KEY-SECRET': API_KEY_SECRET
                }
            });

            const payload = res.data || {};
            const pageData = Array.isArray(payload.data) ? payload.data : [];

            if (pageData.length) {
                collectedBrands.push(...pageData);
            }

            lastPage = typeof payload.last_page === 'number' ? payload.last_page : page;

            page += 1;
        } while (page <= lastPage);

        return collectedBrands;
    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});
